// Список доменов, запрещённых для регистрации (валидация только на фронтенде).
// Обновляется оперативно без изменений бэкенда; используется на странице регистрации
// для проверки поля Email (см. ko/pages/login/main/index.js и views/auth/login.php).
export const BLOCKED_EMAIL_DOMAINS = [
  'gmail.com',
];
